import React, { type ComponentType, lazy, Suspense } from "react";

function lazyAuthEntry(importPage: () => Promise<{ default: ComponentType }>): ComponentType {
  const Page = lazy(importPage);
  return function AuthEntry() {
    return (
      <Suspense fallback={<div aria-busy="true" className="tw-min-h-dvh tw-bg-auth-ground" />}>
        <Page />
      </Suspense>
    );
  };
}

export const RedesignLoginEntry = lazyAuthEntry(() => import("./login-page"));
export const RedesignForgotPasswordEntry = lazyAuthEntry(() => import("./forgot-password-page"));
export const RedesignRecoveryEntry = lazyAuthEntry(() => import("./recovery-page"));
